/** Per-phase pictograms drawn in the ring's core (16x16 viewBox). */
const GLYPH_PATHS: Record<string, string> = {
  lead: '<path d="M8 14.2s4.6-4.3 4.6-7.5A4.6 4.6 0 0 0 3.4 6.7c0 3.2 4.6 7.5 4.6 7.5Z" fill="none" stroke="{c}" stroke-width="1.4" stroke-linejoin="round"/><circle cx="8" cy="6.6" r="1.7" fill="{c}"/>',
  offer:
    '<path d="M4.4 2.6h4.7L12 5.4v8H4.4z" fill="none" stroke="{c}" stroke-width="1.4" stroke-linejoin="round"/><path d="M6.4 8.2h4M6.4 10.6h2.8" stroke="{c}" stroke-width="1.4" stroke-linecap="round"/>',
  secured:
    '<rect x="3.6" y="7" width="8.8" height="6.4" rx="1.4" fill="none" stroke="{c}" stroke-width="1.4"/><path d="M5.8 7V5.5a2.2 2.2 0 0 1 4.4 0V7" fill="none" stroke="{c}" stroke-width="1.4" stroke-linecap="round"/>',
  review:
    '<rect x="3.4" y="2.8" width="9.2" height="10.4" rx="1.4" fill="none" stroke="{c}" stroke-width="1.4"/><path d="m5.9 8.1 1.7 1.7 2.9-3.2" fill="none" stroke="{c}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>',
  won: '<path d="m3.6 8.4 3.1 3.1L12.6 5" fill="none" stroke="{c}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  lost: '<path d="m4.6 4.6 6.8 6.8M11.4 4.6l-6.8 6.8" stroke="{c}" stroke-width="1.8" stroke-linecap="round"/>',
  /** No stage carries this any more — it is what `UNKNOWN_STAGE_STYLE` draws. */
  canceled: '<path d="M4.4 8h7.2" stroke="{c}" stroke-width="1.8" stroke-linecap="round"/>',
};

/** Renders one glyph, filling its `{c}` placeholders with the resolved colour. */
export function glyphMarkup(glyphId: string, color: string): string {
  const template = GLYPH_PATHS[glyphId] ?? GLYPH_PATHS.lead;
  return template.replaceAll('{c}', color);
}

/** The same glyph as a standalone icon, for the card's stage pill. */
export function glyphSvg(glyphId: string, color: string): string {
  return `<svg viewBox="0 0 16 16" fill="none">${glyphMarkup(glyphId, color)}</svg>`;
}
